import styled from 'styled-components'

export const Title = styled.h1`
  font-size: 16px;
  margin: 5px 3px;
`
